import Cookies from 'js-cookie';
import {SOURCE_KEY} from '../constants/cookie';

const CLIENT_COMMS_APP_HANDLER = 'client_app_web_communication_handler';

const PARTNER_COMMS_APP_HANDLER = 'partner_app_communication_handler';

export const sendEventsToNativeApp = (event: string) => {
  const isPartnerApp = getSource()?.includes('partner');
  const handler = isPartnerApp ? PARTNER_COMMS_APP_HANDLER : CLIENT_COMMS_APP_HANDLER;
  try {
    window?.flutter_inappwebview?.callHandler(handler, event);
  } catch (error) {
    console.error(error);
  }
};

export const isInAppWebview = () => {
  const source = Cookies.get(SOURCE_KEY) ?? '';
  return source?.includes('android') || source?.includes('ios');
};
export const getSource = () => Cookies.get(SOURCE_KEY);
